<template>
<v-container fluid fill-height>
    <v-row align="center" justify="center">
        <v-col cols="6">
            <v-card>
        <v-card-title>{{welcome}}</v-card-title>
        <v-card-subtitle>Use the navigation links on the left to get started </v-card-subtitle>
            </v-card>

        </v-col>
    </v-row>
</v-container>

</template>
<script>
export default {
    computed: {
        welcome: function() {
            var hours = new Date().getHours();

            if (hours >=5 && hours < 12) {
                return "Good morning";
            }
            else if(hours >=12 && hours < 18) {
                return "Good afternoon";
            }
            else {
                return "Good evening";
            }
        }
    }
    
}
</script>